import { Injectable } from '@angular/core';

// Carries what the live reply bubble has already typed over to the committed message that
// replaces it, so the commit continues the animation instead of restarting it.
@Injectable({ providedIn: 'root' })
export class StreamedReplyProgressService {
  private text = '';

  publish(shown: string): void {
    this.text = shown;
  }

  /** Read once: a seed must never leak into a later turn. */
  take(): string {
    const shown = this.text;
    this.text = '';
    return shown;
  }
}
